import { combineLatest, map, Observable } from 'rxjs';

export function booleanOr(...observables: Observable<boolean>[]) {
  return combineLatest(observables).pipe(map((o) => o.some(Boolean)));
}
